import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from "vue-router";
const routes = [
  {
    path: "/home",
    name: "home",
    component: () => import("../views/home/Home.vue"),
  },
  //智能座舱
  {
    path: "/",
    name: "home_cockpit",
    component: () => import("../views/home_cockpit/Home.vue"),
    redirect: "/home",
    children: [
      {
        path: "rank/:id",
        name: "rank",
        meta: {
          name: "排行榜",
          permission: 2,
        },
        component: () => import("../views/home_cockpit/rank/Index.vue"),
      },
      {
        path: "report",
        name: "report",
        meta: {
          name: "测评数据",
          permission: 1,
        },
        component: () => import("../views/home_cockpit/report/Home.vue"),
        redirect: "/rank/0",
        children: [
          {
            path: "index",
            name: "reportIndex",
            component: () => import("../views/home_cockpit/report/Index.vue"),
            meta: {
              name: "车型测评",
            },
          },
          {
            path: "change_model",
            name: "change_model",
            component: () =>
              import("../views/home_cockpit/report/ChangeModel.vue"),
            meta: {
              name: "更换车型",
            },
          },
        ],
      },
      {
        path: "summary/first",
        name: "first",
        meta: {
          name: "标杆分析",
        },
        component: () => import("../views/home_cockpit/summary/FirstNode.vue"),
      },

      {
        path: "contrast",
        name: "contrast",
        component: () => import("../views/home_cockpit/contrast/Home.vue"),
        meta: {
          name: "测评对比",
        },
        redirect: "/contrast/select_model",
        children: [
          {
            path: "select_model",
            name: "select_model",
            component: () =>
              import("../views/home_cockpit/contrast/select/Model.vue"),
            meta: {
              name: "测评对比",
              permission: 3,
            },
          },
          {
            path: "analyse",
            name: "analyse",
            component: () =>
              import("../views/home_cockpit/contrast/single/Home.vue"),
            children: [
              {
                path: "base",
                name: "base",
                component: () =>
                  import("../views/home_cockpit/contrast/single/base.vue"),
                meta: {
                  name: "基础项得分",
                },
              },
              {
                path: "func",
                name: "func",
                component: () =>
                  import("../views/home_cockpit/contrast/single/func.vue"),
                meta: {
                  name: "基础项得分",
                },
              },
              {
                path: "search",
                name: "single_search",
                component: () =>
                  import("../views/home_cockpit/contrast/single/Search.vue"),
                meta: {
                  name: "搜索叶子节点",
                },
              },
              {
                path: "trip",
                name: "single_trip",
                component: () =>
                  import("../views/home_cockpit/contrast/single/Trip.vue"),
                meta: {
                  name: "旅途指标得分",
                },
              },
            ],
          },
          {
            path: "multi_analyse",
            name: "multi_analyse",
            component: () =>
              import("../views/home_cockpit/contrast/multi/Home.vue"),
            children: [
              {
                path: "index",
                name: "MultiAnalyse",
                component: () =>
                  import("../views/home_cockpit/contrast/multi/Index.vue"),
                meta: {
                  name: "车型对比",
                },
              },
            ],
          },
          {
            path: "evaluation",
            name: "evaluation",
            component: () =>
              import("../views/home_cockpit/contrast/treeTable/Evaluation.vue"),
            meta: {
              name: "测评数据",
            },
          },
        ],
      },
      // {
      //   path: '/setting/team',
      //   name: 'settingTeam',
      //   meta: {
      //     name: '设置-团队',
      //     role: 1
      //   },
      //   component: () => import('../views/home_cockpit/setting/Team.vue'),
      // },
      {
        path: "/setting/ignoreNode",
        name: "settingIgnoreNode",
        meta: {
          name: "设置-子节点",
        },
        component: () => import("../views/home_cockpit/setting/IgnoreNode.vue"),
      },

      // {
      //   path: '/echarts',
      //   name: 'echarts',
      //   meta: {
      //     name: 'echarts'
      //   },
      //   component: () => import('../views/home_cockpit/echarts/Index.vue')
      // },
      {
        path: "competing",
        name: "competing",
        component: () =>
          import("../views/home_cockpit/competing/Competing.vue"),
        meta: {
          name: "对比竞品列表",
        },
      },
      {
        path: "competinglist",
        name: "competinglist",
        component: () =>
          import("../views/home_cockpit/competing/Competing.vue"),
        meta: {
          name: "竞品列表",
        },
      },
      {
        path: "competingadd",
        name: "competingadd",
        component: () =>
          import("../views/home_cockpit/competing/Competing2.vue"),
        meta: {
          name: "新增竞品",
        },
      },
      {
        path: "overview",
        name: "overview",
        meta: {
          name: "核心场景总览",
        },
        component: () => import("../views/home_cockpit/func/coreScenario.vue"),
      },
      {
        path: "funcVideo",
        name: "funcVideo",
        meta: {
          name: "核心场景分析",
        },
        component: () => import("../views/home_cockpit/func/video.vue"),
      },
      {
        path: "/library",
        name: "library",
        meta: {
          name: "产品库",
          permission: 4,
        },
        component: () => import("../views/library/Library.vue"),
      },
      {
        path: "search",
        name: "many_search",
        meta: {
          name: "智能搜索",
        },
        component: () => import("../views/home_cockpit/search/smartSearch.vue"),
      },
      {
        path: "search_neibu",
        name: "search_neibu",
        meta: {
          name: "内部搜索",
        },
        component: () =>
          import("../views/home_cockpit/search/search_neibu.vue"),
      },
      {
        path: "/setting",
        name: "setting",
        meta: {
          name: "设置",
          role: 1,
        },
        component: () => import("../views/home_cockpit/setting/Setting.vue"),
      },
    ],
  },
  //智能座舱v2
  {
    path: "/v2/",
    name: "home_cockpit_v2",
    component: () => import("../views/v2/home_cockpit/Home.vue"),
    redirect: "/home",
    children: [
      {
        path: "rank/:id",
        name: "rank_v2",
        meta: {
          name: "排行榜",
          permission: 2,
        },
        component: () => import("../views/v2/home_cockpit/rank/Index.vue"),
      },
      {
        path: "report",
        name: "report_v2",
        meta: {
          name: "测评数据",
          permission: 1,
        },
        component: () => import("../views/v2/home_cockpit/report/Home.vue"),
        redirect: "/rank/0",
        children: [
          {
            path: "index",
            name: "reportIndex_v2",
            component: () =>
              import("../views/v2/home_cockpit/report/Index.vue"),
            meta: {
              name: "车型测评",
            },
          },
          {
            path: "change_model",
            name: "change_model_v2",
            component: () =>
              import("../views/v2/home_cockpit/report/ChangeModel.vue"),
            meta: {
              name: "更换车型",
            },
          },
        ],
      },
      {
        path: "summary/first",
        name: "first_v2",
        meta: {
          name: "标杆分析",
        },
        component: () =>
          import("../views/v2/home_cockpit/summary/FirstNode.vue"),
      },

      {
        path: "contrast",
        name: "contrast_v2",
        component: () => import("../views/v2/home_cockpit/contrast/Home.vue"),
        meta: {
          name: "测评对比",
        },
        redirect: "/contrast/select_model",
        children: [
          {
            path: "select_model",
            name: "select_model_v2",
            component: () =>
              import("../views/v2/home_cockpit/contrast/select/Model.vue"),
            meta: {
              name: "测评对比",
              permission: 3,
            },
          },
          {
            path: "analyse",
            name: "analyse_v2",
            component: () =>
              import("../views/v2/home_cockpit/contrast/single/Home.vue"),
            children: [
              {
                path: "base",
                name: "base_v2",
                component: () =>
                  import("../views/v2/home_cockpit/contrast/single/base.vue"),
                meta: {
                  name: "基础项得分",
                },
              },
              {
                path: "func",
                name: "func_v2",
                component: () =>
                  import("../views/v2/home_cockpit/contrast/single/func.vue"),
                meta: {
                  name: "基础项得分",
                },
              },
              {
                path: "func_expand",
                name: "func_expand_v2",
                component: () =>
                  import("../views/v2/home_cockpit/contrast/single/funcExpand.vue"),
                meta: {
                  name: "基础项得分",
                },
              },
              {
                path: "search",
                name: "single_search_v2",
                component: () =>
                  import("../views/v2/home_cockpit/contrast/single/Search.vue"),
                meta: {
                  name: "搜索叶子节点",
                },
              },
              {
                path: "trip",
                name: "single_trip_v2",
                component: () =>
                  import("../views/v2/home_cockpit/contrast/single/Trip.vue"),
                meta: {
                  name: "旅途指标得分",
                },
              },
            ],
          },
          {
            path: "multi_analyse",
            name: "multi_analyse_v2",
            component: () =>
              import("../views/v2/home_cockpit/contrast/multi/Home.vue"),
            children: [
              {
                path: "index",
                name: "MultiAnalyse_v2",
                component: () =>
                  import("../views/v2/home_cockpit/contrast/multi/Index.vue"),
                meta: {
                  name: "车型对比",
                },
              },
            ],
          },
          {
            path: "camp",
            name: "camp",
            component: () =>
              import("../views/v2/home_cockpit/contrast/multi/Home.vue"),
            children: [
              {
                path: "index",
                name: "camp_v2",
                component: () =>
                  import("../views/v2/home_cockpit/contrast/multi/Camp.vue"),
                meta: {
                  name: "阵营对比",
                },
              },
            ],
          },
          {
            path: "price",
            name: "price",
            component: () =>
              import("../views/v2/home_cockpit/contrast/multi/Home.vue"),
            children: [
              {
                path: "index",
                name: "price_v2",
                component: () =>
                  import("../views/v2/home_cockpit/contrast/multi/Price.vue"),
                meta: {
                  name: "价格对比",
                },
              },
            ],
          },
          {
            path: "evaluation",
            name: "evaluation_v2",
            component: () =>
              import(
                "../views/v2/home_cockpit/contrast/treeTable/Evaluation.vue"
              ),
            meta: {
              name: "测评数据",
            },
          },
        ],
      },
      // {
      //   path: '/setting/team',
      //   name: 'settingTeam',
      //   meta: {
      //     name: '设置-团队',
      //     role: 1
      //   },
      //   component: () => import('../views/v2/home_cockpit/setting/Team.vue'),
      // },
      {
        path: "/setting/ignoreNode",
        name: "settingIgnoreNode_v2",
        meta: {
          name: "设置-子节点",
        },
        component: () =>
          import("../views/v2/home_cockpit/setting/IgnoreNode.vue"),
      },

      // {
      //   path: '/echarts',
      //   name: 'echarts',
      //   meta: {
      //     name: 'echarts'
      //   },
      //   component: () => import('../views/v2/home_cockpit/echarts/Index.vue')
      // },
      {
        path: "competing",
        name: "competing_v2",
        component: () =>
          import("../views/v2/home_cockpit/competing/Competing.vue"),
        meta: {
          name: "对比竞品列表",
        },
      },
      {
        path: "competinglist",
        name: "competinglist_v2",
        component: () =>
          import("../views/v2/home_cockpit/competing/Competing.vue"),
        meta: {
          name: "竞品列表",
        },
      },
      {
        path: "competingadd",
        name: "competingadd_v2",
        component: () =>
          import("../views/v2/home_cockpit/competing/Competing2.vue"),
        meta: {
          name: "新增竞品",
        },
      },
      {
        path: "overview",
        name: "overview_v2",
        meta: {
          name: "核心场景总览",
        },
        component: () =>
          import("../views/v2/home_cockpit/func/coreScenario.vue"),
      },
      {
        path: "funcVideo",
        name: "funcVideo_v2",
        meta: {
          name: "核心场景分析",
        },
        component: () => import("../views/v2/home_cockpit/func/video.vue"),
      },
      {
        path: "library",
        name: "library_v2",
        meta: {
          name: "产品库",
          permission: 4,
        },
        component: () => import("../views/v2/library/Library.vue"),
      },
      {
        path: "search",
        name: "many_search_v2",
        meta: {
          name: "智能搜索",
        },
        component: () =>
          import("../views/v2/home_cockpit/search/smartSearch.vue"),
      },
      {
        path: "search_neibu",
        name: "search_neibu_v2",
        meta: {
          name: "内部搜索",
        },
        component: () =>
          import("../views/v2/home_cockpit/search/search_neibu.vue"),
      },
      {
        path: "/setting",
        name: "setting_v2",
        meta: {
          name: "设置",
          role: 1,
        },
        component: () => import("../views/v2/home_cockpit/setting/Setting.vue"),
      },
    ],
  },

  {
    path: "/drive",
    name: "home_drive",
    component: () => import("../views/home_drive/Home.vue"),
    redirect: "/drive/rank/0",
    children: [
      {
        path: "rank/:id",
        name: "rank_drive",
        meta: {
          name: "排行榜",
          permission: 2,
        },
        component: () => import("../views/home_drive/rank/Index.vue"),
      },
      {
        path: "report",
        name: "report_drive",
        meta: {
          name: "测评数据",
          permission: 1,
        },
        component: () => import("../views/home_drive/report/Home.vue"),
        redirect: "/drive/rank/0",
        children: [
          {
            path: "index",
            name: "reportIndex_drive",
            component: () => import("../views/home_drive/report/Index.vue"),
            meta: {
              name: "车型测评",
            },
          },
          {
            path: "change_model",
            name: "change_model_drive",
            component: () =>
              import("../views/home_drive/report/ChangeModel.vue"),
            meta: {
              name: "更换车型",
            },
          },
        ],
      },
      {
        path: "summary/first",
        name: "first_drive",
        meta: {
          name: "标杆分析",
        },
        component: () => import("../views/home_drive/summary/FirstNode.vue"),
      },
      {
        path: "contrast",
        name: "contrast_drive",
        component: () => import("../views/home_drive/contrast/Home.vue"),
        meta: {
          name: "测评对比",
        },
        redirect: "/drive/rank",
        children: [
          {
            path: "analyse",
            name: "analyse_drive",
            component: () =>
              import("../views/home_drive/contrast/single/Home.vue"),
            children: [
              {
                path: "base",
                name: "base_drive",
                component: () =>
                  import("../views/home_drive/contrast/single/base.vue"),
                meta: {
                  name: "基础项得分",
                },
              },
              {
                path: "search",
                name: "single_search_drive",
                component: () =>
                  import("../views/home_drive/contrast/single/Search.vue"),
                meta: {
                  name: "搜索叶子节点",
                },
              },
            ],
          },
          {
            path: "multi_analyse",
            name: "multi_analyse_drive",
            component: () =>
              import("../views/home_drive/contrast/multi/Home.vue"),
            children: [
              {
                path: "index",
                name: "MultiAnalyse_drive",
                component: () =>
                  import("../views/home_drive/contrast/multi/Index.vue"),
                meta: {
                  name: "车型对比",
                },
              },
            ],
          },
          {
            path: "evaluation",
            name: "evaluation_drive",
            component: () =>
              import("../views/home_drive/contrast/treeTable/Evaluation.vue"),
            meta: {
              name: "创新项得分",
            },
          },
        ],
      },
      {
        path: "competing",
        name: "competing_drive",
        component: () => import("../views/home_drive/competing/Competing.vue"),
        meta: {
          name: "竞品列表",
        },
      },
      {
        path: "competingadd",
        name: "competingadd_drive",
        component: () => import("../views/home_drive/competing/Competing2.vue"),
        meta: {
          name: "新增竞品",
        },
      },
      {
        path: "overview",
        name: "drive_overview",
        meta: {
          name: "核心场景总览",
        },
        component: () => import("../views/home_drive/func/coreScenario.vue"),
      },
      {
        path: "funcVideo",
        name: "funcVideo_drive",
        meta: {
          name: "核心场景分析",
        },
        component: () => import("../views/home_drive/func/video.vue"),
      },
      {
        path: "library",
        name: "library_drive",
        meta: {
          name: "产品库",
          permission: 4,
        },
        component: () => import("../views/library/Library.vue"),
      },
      {
        path: "search",
        name: "search_drive",
        meta: {
          name: "智能搜索",
        },
        component: () => import("../views/home_drive/search/smartSearch.vue"),
      },
      {
        path: "search_neibu",
        name: "search_drive_neibu",
        meta: {
          name: "内部搜索",
        },
        component: () => import("../views/home_drive/search/search_neibu.vue"),
      },
      {
        path: "setting/ignoreNode",
        name: "settingIgnoreNode_drive",
        meta: {
          name: "设置-子节点",
        },
        component: () => import("../views/home_drive/setting/IgnoreNode.vue"),
      },
    ],
  },
  {
    path: "/service",
    name: "service",
    redirect: "/service/downloads",
    meta: {
      name: "服务",
    },
    component: () => import("../views/service/Home.vue"),
    children: [
      {
        path: "downloads",
        name: "service_downloads",
        meta: {
          name: "下载",
        },
        component: () => import("../views/service/downloads/downloads.vue"),
      },
      {
        path: "/service/sales/list",
        name: "service_sales_list",
        meta: {
          name: "销量排行",
        },
        component: () => import("../views/service/sales/List.vue"),
      },
      {
        path: "/service/sales/detail",
        name: "service_sales_detail",
        meta: {
          name: "销量详情",
        },
        component: () => import("../views/service/sales/Detail.vue"),
      },
      {
        path: "/service/ota/index",
        name: "service_ota_index",
        meta: {
          name: "OTA首页",
        },
        component: () => import("../views/service/ota/Index.vue"),
      },
      {
        path: "/service/otaCount/index",
        name: "service_otaCount_index",
        meta: {
          name: "OTA统计",
        },
        component: () => import("../views/service/otaCount/Index.vue"),
      },
      {
        path: "/service/otaCompare/index",
        name: "service_otaCompare_index",
        meta: {
          name: "OTA车型对比",
        },
        component: () => import("../views/service/otaCompare/Index.vue"),
      },
      {
        path: "/service/otaCompare/detail",
        name: "service_otaCompare_detail",
        meta: {
          name: "OTA车型对比详情",
        },
        component: () => import("../views/service/otaCompare/Detail.vue"),
      },
      {
        path: "/service/otaBrandCompare/index",
        name: "service_otaBrandCompare_index",
        meta: {
          name: "OTA品牌对比",
        },
        component: () => import("../views/service/otaBrandCompare/Index.vue"),
      },
      {
        path: "/service/otaBrandCompare/detail",
        name: "service_otaBrandCompare_detail",
        meta: {
          name: "OTA品牌对比详情",
        },
        component: () => import("../views/service/otaBrandCompare/Detail.vue"),
      },
      {
        path: "/service/otaSearch/index",
        name: "service_otaSearch_index",
        meta: {
          name: "OTA全局搜索",
        },
        component: () => import("../views/service/otaSearch/Index.vue"),
      },
      {
        path: "/service/ota/detail",
        name: "service_ota_detail",
        meta: {
          name: "OTA详情",
        },
        component: () => import("../views/service/ota/Detail.vue"),
      },
    ],
  },

  // {
  //   path: '/sales',
  //   name: 'sales',
  //   children:[
  //     {
  //       path: 'rank',
  //       name: 'sales_rank',
  //       meta: {
  //         name: '销量榜'
  //       },
  //       component: () => import('../views/sales/List.vue')
  //     },
  //     {
  //       path: 'detail',
  //       name: 'sales_detail',
  //       meta: {
  //         name: '销量详情'
  //       },
  //       component: () => import('../views/sales/Detail.vue')
  //     }
  //   ]
  // },
  {
    path: "/login",
    name: "login",
    meta: {
      name: "登录",
    },
    component: () => import("../views/login/Login.vue"),
  },
  {
    path: "/introduct",
    name: "introduct",
    meta: {
      name: "介绍",
    },
    component: () => import("../views/introduct/Index.vue"),
  },
  {
    path: "/login_ewm",
    name: "login_ewm",
    meta: {
      name: "登录二维码",
    },
    component: () => import("../views/login/WxCode.vue"),
  },
  {
    path: "/bind_ewm",
    name: "bind_ewm",
    meta: {
      name: "绑定二维码",
    },
    component: () => import("../views/login/WxCode.vue"),
  },
  {
    path: "/login/findPwd",
    name: "login_findPwd",
    meta: {
      name: "找回密码",
    },
    component: () => import("../views/login/findPwd.vue"),
  },
  {
    path: "/login/reset",
    name: "login_reset",
    meta: {
      name: "重置密码",
    },
    component: () => import("../views/login/pwdReset.vue"),
  },
  // {
  //   path: '/login/success',
  //   name: 'reset_success',
  //   meta: {
  //     name: '重置成功'
  //   },
  //   component: () => import('../views/login/resetSuccess.vue')
  // },
  {
    path: "/error",
    name: "notFound",
    component: () => import("../views/home_cockpit/Home.vue"),
    children: [
      {
        path: "404",
        name: "error404",
        component: () => import("../views/NotFound.vue"),
        meta: {
          name: "404 NotFound",
        },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)",
    redirect: "/error/404",
  },
];

const router = createRouter({
  history:
    process.env.NODE_ENV == "production"
      ? createWebHistory()
      : createWebHashHistory(),
  routes,
});
export default router;
